export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_USER = 'SET_USER';
export const SET_STADIUM = 'SET_STADIUM';
export const SET_DOOR = 'SET_DOOR';
export const SET_PANIER = 'SET_PANIER';
export const SET_PANIER_REFERENCE = 'SET_PANIER_REFERENCE';
export const SET_PRODUCT_TO_SHOW = 'SET_PRODUCT_TO_SHOW';
export const SET_SELECTED_PDV = 'SET_SELECTED_PDV';
export const SET_EVENT = 'SET_EVENT';
export const SET_SELECTED_CARD = 'SET_SELECTED_CARD';
export const SET_TIME_CREATION_PANIER = 'SET_TIME_CREATION_PANIER';
